import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

import { TableComponent } from './table.component';
import { SortModule } from './sort/sort.module';
import { TableTopComponent } from './table-top/table-top.component';
import { ButtonHideShowComponent } from './table-top/button-hide-show/button-hide-show.component';
import { EditLinkComponent } from './row-components/edit-link/edit-link.component';
import { DeleteButtonComponent } from './row-components/delete-button/delete-button.component';
import { EllipsisComponent } from './row-components/ellipsis/ellipsis.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { TableFilterComponent } from './table-top/table-filter/table-filter.component';
import { ButtonFilterComponent } from './table-top/button-filter/button-filter.component';
import { ButtonResetFilterComponent } from './table-top/button-reset-filter/button-reset-filter.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
	declarations: [ TableComponent, TableTopComponent, ButtonHideShowComponent,
		// Components to be used by developers outside of table module
		EditLinkComponent, DeleteButtonComponent, EllipsisComponent, TableFilterComponent, ButtonFilterComponent, ButtonResetFilterComponent ],
	imports: [
		CommonModule, FormsModule, RouterModule,
		CdkTableModule, NgbPaginationModule, SortModule, NgbTooltipModule,
		NgxMaskModule.forRoot(),
	],
	exports: [ TableComponent, CdkTableModule, SortModule,
		// Components to be used by developers outside of table module
		EditLinkComponent, DeleteButtonComponent, EllipsisComponent, TableFilterComponent ]
})
export class TableModule { }
